import Cookies from 'universal-cookie';

const postPingPayload = (formData) => {
  const cookies = new Cookies();
  const deviceId = cookies.get('deviceId') ?? 'empty';

  const payload = { deviceId, operatorPresenceId: formData?.presence?.id };

  return payload;
};

export default postPingPayload;
